import { render, staticRenderFns } from "./PopoverObligeFacture.vue?vue&type=template&id=ec88cb4c&scoped=true&"
import script from "./PopoverObligeFacture.vue?vue&type=script&lang=js&"
export * from "./PopoverObligeFacture.vue?vue&type=script&lang=js&"
import style0 from "./PopoverObligeFacture.vue?vue&type=style&index=0&id=ec88cb4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec88cb4c",
  null
  
)

export default component.exports